export enum InsuranceSelectionAgreementEnum {
    None = "none",
    Agree = "agree",
    Disagree = "disagree",
}